var render, staticRenderFns
import script from "./CbsContextMenu.vue?vue&type=script&lang=js&"
export * from "./CbsContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./CbsContextMenu.vue?vue&type=style&index=0&id=a56ee18c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56ee18c",
  null
  
)

export default component.exports